import { CartState } from 'types/redux'

const preloadedCartState: CartState = {
  collectiveOrder: false,
  redPointsBalance: 0,
  data: null,
  voucherAccepted: false,
  voucherLoad: false
}

export default preloadedCartState
